export default "__VITE_ASSET__DCkE1smD__"